module.exports = __webpack_public_path__ + "assets/img/path-test.31df4263.svg";